import { TemplateTypeDisplay } from "../../../../../core/entities/templateTypeDisplay";
import { TemplateProfile } from "../../../../../core/entities/templateProfile";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useServiceContext } from "../../../../../contexts/ServiceContext";
import React, { useState } from "react";
import { Dictionary } from "../../../../../core/models/dictionary";
import { Template, TemplateType } from "../../../../../core/entities/template";
import { SelectedButton } from "../../../../components/navigation/SelectedButton";
import { TemplateOverview_VM } from "../TemplateOverview.Component";
import { ReplacementField } from "../../../../../core/entities/replacementField";

export function useTemplateOverviewViewModel(
    templateTypes: TemplateTypeDisplay[],
    templateProfiles: TemplateProfile[],
    replaceProfile: (profile: TemplateProfile) => void,
    replacementFields: ReplacementField[]
): TemplateOverview_VM {
    const [qp] = useSearchParams();
    const navigate = useNavigate();
    const {
        templateService: { newDraft, copyToDraft }
    } = useServiceContext();
    const [selectedType, setSelectedType] = useState<TemplateType>(
        qp.has("type")
            ? (Number(qp.get("type")) as TemplateType)
            : templateTypes[0].key
    );

    const [selectedTemplatesPerTypes, setSelectedTemplatesPerTypes] = useState<
        Dictionary<Template>
    >(getInitialVisibleState(templateProfiles));
    const selectedProfile = templateProfiles.find(
        (x) => x.type === selectedType
    );
    const selectedTemplate = selectedTemplatesPerTypes[
        selectedType
    ] as Template;

    const typeButtonComponents = templateTypes.map((x) => (
        <SelectedButton
            key={x.key}
            selected={x.key === selectedType}
            onClick={() => setSelectedType(x.key)}
        >
            {x.displayValue}
        </SelectedButton>
    ));

    function handleMakeDraft() {
        newDraft(selectedType).then((x) => {
            replaceProfile(x);
            SetSelectedTemplate(x.type, x.draft!);
        });
    }

    function SetSelectedTemplate(type: TemplateType, template: Template) {
        setSelectedTemplatesPerTypes((dirc) => ({
            ...dirc,
            [type]: template
        }));
    }

    function handleMakeCopy(template: Template) {
        if (!selectedProfile) {
            console.warn("profile was null");
            return;
        }

        copyToDraft(selectedProfile.type, template.id).then((x) => {
            replaceProfile(x);
            SetSelectedTemplate(x.type, x.draft!);
        });
    }

    function handleEdit(selectedTemplate: Template) {
        if (!selectedTemplate) {
            console.warn("no template was selected");
            return;
        }
        navigate(`${selectedTemplate.type}/edit`);
    }

    return {
        selectedProfile,
        selectedTemplate,
        typeButtonComponents,
        onMakeDraft: handleMakeDraft,
        onSelectTemplate: SetSelectedTemplate,
        onMakeCopy: handleMakeCopy,
        onEditTemplate: handleEdit,
        replacementFields: replacementFields
    };
}

function getInitialVisibleState(
    profiles: TemplateProfile[]
): Dictionary<Template> {
    const templateDirc: Dictionary<Template> = {};
    for (const profile of profiles) {
        templateDirc[profile.type] = getInitialVisible(profile);
    }
    return templateDirc;
}

function getInitialVisible(profile: TemplateProfile) {
    if (profile.published) {
        return profile.published;
    }
    if (profile.draft) {
        return profile.draft;
    }
}
